<script>
import { Line, mixins } from "vue-chartjs";
import { getRandomColor } from "../../src/base";
import { lavalinkInfo } from "../base";


export default {
  extends: Line,
  mixins: [mixins.reactiveData],
  data() {
    return {
      chartData: "",
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: true,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              if (tooltipItem.datasetIndex === 0) {
                return value + " DESTROYED PLAYERS";
              } else {
                return value + " ACTIVE PLAYERS";
              }
            },
          },
        },

      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  async created() {
    await lavalinkInfo()
      .then((response) => {
      // console.log(response);
      //map all date inside response.data.stats_daily, and filter empty arrays.
        let dateData = response.map((item) => {
          return item.date;
        });

        let dataPlayer = response.map((item) => {
          return item.data;
        });

        // create destroyedPlayer with dataPlayer - previous array, and change all negative value to 0.
        // change NaN to 0
        let destroyedPlayer = dataPlayer.map((item, index) => {
          let difference = item - dataPlayer[index - 1];
          return isNaN(difference) ? 0 : (difference < 0 ? 0 : difference);
        });

        // console.log(destroyedPlayer);

      
        //const color1 = getRandomColor();
        //const color_x = getRandomColor();
        const color_y = getRandomColor();
        //const color_xx = getRandomColor();
        const color_yy = getRandomColor();
      

        this.chartData = {
          labels: dateData,
          datasets: [
       
            {
              label: "DESTROYED PLAYERS",
              backgroundColor: getRandomColor(),
              //pointBackgroundColor: color1,
              borderWidth: 4,
              pointBorderColor: color_yy,
              data: destroyedPlayer,
            },
            {
              label: "ACTIVE PLAYERS",
              backgroundColor: getRandomColor(),
              //pointBackgroundColor: color_x,
              borderWidth: 4,
              pointBorderColor: color_y,
              data: dataPlayer,
            },
          
          ],
        };

      
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
};
</script>
